<template>
  <div class="container">
    <van-nav-bar left-arrow
                 @click-left="onClickLeft" fixed title="确认付款"/>
    <div class="pay_order_info">
      <div class="pay_info_box">
        <p class="info_label">就诊人</p>
        <div class="info_value">
          {{ detailInfo.userMemberName }}&emsp;{{ sexFilter(detailInfo.sex) }}&emsp;{{ detailInfo.age }}岁
        </div>
      </div>
      <div class="pay_info_box">
        <p class="info_label">预约医生</p>
        <p class="info_value">{{ detailInfo.doctorName }}—{{ detailInfo.clinicalTitle }}</p>
      </div>
      <div class="pay_info_box">
        <p class="info_label">问诊方式</p>
        <p class="info_value">{{ askTypeFilter(detailInfo.askType) }}</p>
      </div>
      <div class="pay_info_box">
        <p class="info_label">预约时间</p>
        <p class="info_value">{{ detailInfo.apptStartTime }}-{{ detailInfo.apptEndTime }}</p>
      </div>
    </div>
    <div class="pay_order_info">
      <div class="pay_info_box">
        <p class="info_label">订单编号</p>
        <div class="info_value">
          <p>{{ detailInfo.registerNo }}</p>
          <p class="copy_btn" @click="copyToClipboard(detailInfo.registerNo)">复制</p>
        </div>
      </div>
      <div class="pay_info_box">
        <p class="info_label">挂号费</p>
        <p class="info_value">￥{{ detailInfo.askServiceFee }}</p>
      </div>
      <div class="pay_info_box" v-if="Number(payRouteInfo.couponPrice)">
        <p class="info_label">优惠金额</p>
        <p class="info_value">￥{{ payRouteInfo.couponPrice }}</p>
      </div>
      <div class="actual_payment_box">实付金额：<span
          class="red">￥{{ subtract(detailInfo.askServiceFee, Number(payRouteInfo.couponPrice)) }}</span></div>
    </div>
    <div class="pay_btn_box">
      <p class="amount_money">￥{{ subtract(detailInfo.askServiceFee, Number(payRouteInfo.couponPrice)) }}</p>
      <p class="confirm_payment_btn" @click="confirmPayment">确认付款</p>
    </div>
  </div>
</template>
<script>
import api from "@/utils/request";
import {sexFilter, askTypeFilter} from "@/filters";
import {copyToClipboard} from "@/utils/utils";

export default {
  data() {
    return {
      submitable: true,
      detailInfo: {},
      payRouteInfo: {couponPrice: 0},
    }
  },
  methods: {
    sexFilter,
    askTypeFilter,
    copyToClipboard,
    async getAskDetail() {
      const {
        data: {askInfoDoctor: detailInfo},
      } = await api({
        method: "get",
        url: "/user-service/app/askinfo/getByAskNo",
        params: {
          askNo: this.$route.query.askNo,
        },
      });
      this.detailInfo = detailInfo
    },
    async confirmPayment() {
      if (!this.submitable) return false;
      this.submitable = false;
      try {
        const {data = {}} = await api({
          method: "post",
          url: "/order-service/pay/unifiedOrderV2",
          data: {
            payType: this.payRouteInfo.payType,
            orderNo: this.detailInfo.registerNo,
            couponId: Number(this.payRouteInfo.couponId),
            origin: 2,
			payForAnother: Number(this.payRouteInfo.payForAnother || 0)
          },
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (data.freeOrder == "1") {
          this.$toast("支付成功");
          setTimeout(() => {
            this.submitable = true;
            this.$router.back();
          }, 1000);
        } else {
          window.location.href = data.paySkipUrl
        }
      } catch (error) {
      }
      this.submitable = true;
    },
    // 减法运算
    subtract(a, b) {
      return this.transferToNumber(this.add(a, -b)) || 0;
    },
    // 加法运算
    add(a, b) {
      const precision = Math.max(this.getPrecision(a), this.getPrecision(b));
      const multiplier = Math.pow(10, precision);
      const result = (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
      return this.transferToNumber(result)
    },
    getPrecision(num) {
      const str = String(num);
      const decimalIndex = str.indexOf(".");
      return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
    },
    // 处理出现科学计数法
    transferToNumber(num) {
      if (isNaN(num)) {
        return num
      }
      num = '' + num
      num = parseFloat(num)
      let eformat = num.toExponential() // 转换为标准的科学计数法形式（字符串）
      let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/) // 分离出小数值和指数值
      let number = num.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]))
      return number
    },
    onClickLeft() {
      this.$router.back()
    }
  },
  created() {
    this.getAskDetail()
    this.payRouteInfo = this.$route.query
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/css/base";

$mainColor: #2f4593;
.red {
  color: red;
}

.main_color {
  color: $mainColor;
}

.container {
  //height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  font-size: 14px;
  padding-bottom: 70px;
  padding-top: 40px;
}

.pay_order_info {
  margin-top: 10px;
  padding: 0 12px;
  background: #fff;

  .pay_info_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .info_label {
    }

    .info_value {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;

      .copy_btn {
        margin-left: 4px;
      }
    }
  }


  .actual_payment_box {
    text-align: right;
    font-weight: bold;
    padding-bottom: 10px;
  }

}

.pay_btn_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;

  .amount_money {
    font-size: 18px;
    font-weight: bold;
    color: red;
  }

  .confirm_payment_btn {
    background: $mainColor;
    text-align: center;
    border-radius: 30px;
    padding: 10px 12px;
    color: #FFFFFF;

  }
}
</style>